// extracted by mini-css-extract-plugin
export default {"container":"S02_container__mVMNZ","limiter":"S02_limiter__KZ4rb"};